const autoNgTemplateLoaderTemplate1 = require('./registriesDatatable.html');

angular.module('portainer.app').component('registriesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    accessManagement: '<',
    removeAction: '<',
    canBrowse: '<',
  },
});
